module.exports = __webpack_public_path__ + "media/components/maps/forms/images/restriction-zone-green-a2fcfc17dfcb12218065255081be9ce5.svg";